import React, { useState } from 'react';
import styles from './FlippableCard.module.css';
import alex from '../../assets/alex.jpg';

type CardProps = {
  name: string;
  role: string;
  description: string;
  imageSource: any;
};

const FlippableCard = ({ name, role, description, imageSource }: CardProps) => {
  const [flipped, setFlipped] = useState(false);

  return (
    <div className={styles.card}>
      <div
        className={`${styles.innerCard} ${flipped ? styles.cardFlipped : ''}`}
        onClick={() => setFlipped(!flipped)}
      >
        <div className={`${styles.cardFace} ${styles.cardFaceFront} `}>
          <div
            className={styles.cardFrontImage}
            style={{
              backgroundImage: `url(${imageSource})`,
            }}
          ></div>
          <div className={styles.cardFooter}>
            <h2 className={styles.cardHolder}>{name}</h2>
            <h5 className={styles.cardHolderRole}>{role}</h5>
          </div>
        </div>

        <div className={` ${styles.cardFace} ${styles.cardFaceBack}`}>
          <div className={styles.cardContent}>
            <div className={styles.cardBody}>
              <p className={styles.backText}>{description}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FlippableCard;
